import { HTTP } from '@/http-common';

const state = {};
const getters = {};
const actions = {
  async updateLayoutFields({}, payload) {
    let refs = Object.entries(payload.refs).map((x) => x[0]);
    try {
      let response = await HTTP.post(
        `layout/UpdateLayoutFields/${payload.component}`,
        refs
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLayoutFields({}, component) {
    try {
      let response = await HTTP.get(`layout/getLayoutFields/${component}`);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
